export const APP_CONFIRM_EVENT = 'app:confirm';

const resolvers = new Map();

export const confirmDialog = (message, title = 'Confirm') =>
  new Promise((resolve) => {
    const id = `confirm-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    resolvers.set(id, resolve);
    window.dispatchEvent(
      new CustomEvent(APP_CONFIRM_EVENT, {
        detail: { id, message: String(message || '').trim() || 'Continue?', title: String(title || 'Confirm').trim() },
      })
    );
  });

export const resolveConfirm = (id, result) => {
  const resolve = resolvers.get(id);
  if (resolve) {
    resolvers.delete(id);
    resolve(!!result);
  }
};
